module.exports = __webpack_public_path__ + "static/star-00269aeda279deabc0da37243fbc32f1.png";